<div class="page admin js-page">
  <app-dashboard-side-nav  class="hidden-print sidenav" (onComponentSelected)="select($event)"></app-dashboard-side-nav>
  <div class="adminpanel">
    <div class="adminobjects" id="objects_dashboard" *ngIf="isSelected('objects_dashboard')" app-objects-dashboard></div>
    <div class="adminobjects" id="drivers_dashboard" *ngIf="isSelected('drivers_dashboard')" app-drivers-dashboard></div>
    <div class="adminobjects" id="objects_reports" *ngIf="isSelected('objects_reports')" app-objects-report></div>
  </div>
</div>
